import type { UIMatch } from 'react-router';

export function combinedLoaderHandle<TProps>(_matches: unknown[]) {
  const matches = _matches as UIMatch[];
  const combinedProps: Record<string, unknown> = {};

  for (const match of matches) {
    const matchLoaderDataHandle =
      match.loaderData &&
      typeof match.loaderData === 'object' &&
      'handle' in match.loaderData &&
      typeof match.loaderData.handle === 'object'
        ? match.loaderData.handle
        : {};

    Object.assign(combinedProps, matchLoaderDataHandle);
  }

  return combinedProps as TProps;
}
